var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',[_c('div',{staticClass:"welcome"},[_c('img',{attrs:{"src":require("../assets/login/logo2.png")}}),_c('p',[_vm._v("欢迎使用南阳经开高标准数字园区综合服务平台管理后台")])])])])
}]

export { render, staticRenderFns }